import React from "react";
import styled from "styled-components";
import { BoxSpinner } from "components/generic/kit";
import Overlay from "./Overlay";
import Navbar from "./Navbar";
import logo from "./assets/powered_by_stripe.svg";

export default ({ isLoading, title, children, sidebar, step, bigTitle }) => (
  <Overlay checkout>
    {step === "checkout" && <Navbar step={3} title="Complete Booking" />}
    <Container>
      {isLoading ? (
        <BoxSpinner />
      ) : (
        <React.Fragment>
          <div className="pa5-ns pt4 ph6-ns">
            <div className="flex flex-column-reverse items-start flex-row-l justify-center ">
              <Wrap className="w-50-ns w-100 bg-white ph4-ns ph0 mr4-ns br2">
                <WrapBooking>
                  <Title>{bigTitle}</Title>
                  <div className="flex mb2 items-start mt4 ph5-ns ph3 w-100">
                    <div
                      className="mb3 w-50
                m3-l"
                      style={{ fontFamily: "CircularStd-Book" }}
                    >
                      {title}
                    </div>
                    {step === "checkout" && (
                      <img src={logo} className="ml-auto" alt="stripe" />
                    )}
                  </div>
                  {children()}
                </WrapBooking>
              </Wrap>
              <div className="db w-50-ns">{sidebar}</div>
            </div>
          </div>
        </React.Fragment>
      )}
    </Container>
  </Overlay>
);

const Container = styled.div`
  width: calc(100% - 20px);
  margin: 0 auto;
  background-color: #f9f7f2;
  @media (max-width: 680px) {
    width: 100%;
    background-color: #f9f7f2;
  }
`;

const Wrap = styled.div`
  box-shadow: 15px 15px #ebe8e1;
  @media (max-width: 680px) {
    box-shadow: unset;
  }
`;

const Title = styled.div`
  position: relative;
  font-size: 42px;
  @media (max-width: 680px) {
    display: none;
  }
`;

const WrapBooking = styled.div`
  top: -50px;
  position: relative;
  @media (max-width: 680px) {
    top: unset;
  }
`;



// WEBPACK FOOTER //
// ./src/components/common/candidate/BookWrap.js